export default __webpack_public_path__ + "static/media/img2.9faa571b.svg";